import { createSlice } from '@reduxjs/toolkit';

export const authSlice = createSlice({
    name: 'auth',
    initialState: { accessToken: undefined, permissions: [] },
    reducers: {
        setAccessToken(state, action) {
            const { accessToken, permissions } = action.payload;
            return { ...state, accessToken, permissions };
        },
    },
});

export const { setAccessToken } = authSlice.actions;
